import _ from 'lodash';
import {get, post} from 'sdk';
import {BASE_URL} from 'appConstants';

import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {getFormattedDateForApiOrValue} from 'utils/datetime';
import {transformSortForStoreToSortForUrl} from 'utils/sort';

export const fetchInvoicesForReporting = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/invoices/report/`;

  return get(url, extraGetParams);
};

export const fetchBookingOptions = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/invoices/booking-options/`;

  return get(url, {search});
};

export const fetchCustomerOptions = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/living/tenant/${locationRef}/primary/`;

  return get(url, {search});
};

export const fetchAdminOptions = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/invoices/created-by-options/`;

  return get(url, {search});
};

export const fetchExcludedInvoicesFromPaymentInitiation = ({invoicesIds}) => {
  const url = `${BASE_URL}/v1/payments/gocardless/initiate-payments/excluded-invoices/`;

  return post(url, {invoicesIds});
};

export const previewInvoicesForPaymentInitiation = ({invoicesIds}) => {
  const url = `${BASE_URL}/v1/payments/gocardless/initiate-payments/preview-invoices/`;

  return post(url, {invoicesIds});
};

export const bulkInitiateGoCardlessPayments = ({
  invoicesIds,
  specifiedDesiredPaymentDate,
  takePaymentAtEarliestChargeDate
}) => {
  const url = `${BASE_URL}/v1/payments/gocardless/initiate-payments/`;

  return post(url, {
    invoicesIds,
    specifiedDesiredPaymentDate,
    takePaymentAtEarliestChargeDate
  });
};
export const exportInvoicesCsv = ({
  locationRef,
  invoicesIds,
  filterParams,
  sort
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/invoices/export-csv/`;

  const normalizedFilters = _.mapValues(
    filterParams,
    getFormattedDateForApiOrValue
  );

  const filters = {
    ...transformFiltersForStoreToFiltersForApi(normalizedFilters),
    ...transformSortForStoreToSortForUrl(sort)
  };

  return post(url, {invoicesIds, filters});
};

export const fetchRevenueSummary = ({locationRef, resolution}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/summary/`;

  return get(url, {resolution});
};

export const fetchLookerRevenueUrl = ({locationRef, resolution}) => {
  const url = `${BASE_URL}/v1/locations/dashboard/looker/revenue/${locationRef}/`;
  return get(url, {resolution});
};

export const fetchRevenueReport = ({
  locationRef,
  resolution,
  periodStart,
  periodEnd
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/report/`;

  return get(url, {resolution, periodStart, periodEnd});
};

export const exportRevenue = ({
  locationRef,
  resolution,
  summaryResolution,
  periodStart,
  periodEnd
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/export-excel/`;

  return get(url, {
    locationRef,
    resolution,
    summaryResolution,
    periodStart,
    periodEnd
  });
};

export const exportInvoicesRaised = ({locationRef, periodStart, periodEnd}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/export-invoices-raised-in-background/`;

  return get(url, {
    periodStart,
    periodEnd
  });
};

export const exportContractedRevenue = ({
  locationRef,
  periodStart,
  periodEnd
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/export-contracted-revenue-in-background/`;

  return get(url, {
    periodStart,
    periodEnd
  });
};

export const exportContractedRevenueV2 = ({
  locationRef,
  periodStart,
  periodEnd
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/revenue/export-contracted-revenue-v2-in-background/`;

  return get(url, {
    periodStart,
    periodEnd
  });
};
